// Lightweight text-to-speech using the browser Web Speech API.
export function speak(text, lang = "en", rate = 0.92, onEnd = null) {
  if (typeof window === "undefined" || !window.speechSynthesis) { if (onEnd) onEnd(); return; }
  window.speechSynthesis.cancel();
  const utter = new SpeechSynthesisUtterance(text);
  utter.lang = lang === "fr" ? "fr-FR" : "en-GB";
  const pick = pickVoice(lang);
  try { if (pick) utter.voice = pick; } catch (e) { /* default voice */ }
  utter.rate = rate;
  utter.pitch = 1.05;
  if (onEnd) { utter.onend = onEnd; utter.onerror = onEnd; }
  window.speechSynthesis.speak(utter);
}

export function stopSpeak() {
  if (typeof window !== "undefined" && window.speechSynthesis) {
    window.speechSynthesis.cancel();
  }
}

export function speechSupported() {
  return typeof window !== "undefined" && !!window.speechSynthesis;
}

// Best installed voice for a language: France French first (not Canadian), clear "enhanced/premium" voices preferred.
export function pickVoice(lang) {
  if (typeof window === "undefined" || !window.speechSynthesis) return null;
  const vs = window.speechSynthesis.getVoices().filter((v) => v.lang.toLowerCase().replace("_", "-").startsWith(lang));
  if (!vs.length) return null;
  const main = lang === "fr" ? "fr-fr" : "en-gb";
  const score = (v) => (v.lang.toLowerCase().replace("_", "-") === main ? 4 : 0)
    + (/premium|enhanced|amélioré|natural|neural/i.test(v.name) ? 2 : 0) + (v.localService ? 3 : 0)
    - (/network/i.test(v.name) ? 3 : 0); // streamed voices stutter on weak connections
  return vs.sort((a, b) => score(b) - score(a))[0];
}

if (typeof window !== "undefined" && window.speechSynthesis) {
  window.speechSynthesis.getVoices();
  window.speechSynthesis.addEventListener?.("voiceschanged", () => window.speechSynthesis.getVoices());
}

// Android/Chrome load the voice list late: wait (max ~1.5 s) so French is not sent to the online voice by mistake.
let voicesPromise = null;
export function voicesReady(timeout = 1500) {
  if (typeof window === "undefined" || !window.speechSynthesis) return Promise.resolve();
  if (window.speechSynthesis.getVoices().length) return Promise.resolve();
  if (!voicesPromise) {
    voicesPromise = new Promise((resolve) => {
      const t0 = Date.now();
      const iv = setInterval(() => {
        if (window.speechSynthesis.getVoices().length || Date.now() - t0 > timeout) { clearInterval(iv); voicesPromise = null; resolve(); }
      }, 100);
    });
  }
  return voicesPromise;
}
